module.exports = __webpack_public_path__ + "img/user-nav-photos.b48c0ec4.svg";